const findKey = (obj, cb = () => null) => {
  if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      if (typeof obj[i] === 'object' && obj[i] !== null) {
        findKey(obj[i], cb)
      }
    }
  } else if (typeof obj === 'object' && obj !== null) {
    for (let key in obj) {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        findKey(obj[key], cb)
      } else if (
        (key === 'value' && typeof obj[key] === 'string') ||
        (key === 'content' && typeof obj[key] === 'string')
      ) {
        obj[key] = cb(obj[key])
      }
    }
  }
}

/**
 * Recursively searches an object or array for a 'value' key and replaces its value with the result of the provided callback function.
 *
 * @param {object|array} obj - The object or array to search.
 * @param {function} cb - The callback function to apply to the 'value' key.
 * @return {void} This function does not return a value.
 */
export const findKeyAndReplaceValue = (arg, cb) => {
  const newVar = arg
  findKey(newVar, cb)

  return newVar
}
